var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 7.5V17.5C5.5 18.6046 6.39543 19.5 7.5 19.5H17.5C18.6046 19.5 19.5 18.6046 19.5 17.5001V7.5H21.5V17.5001C21.5 19.7092 19.7091 21.5 17.5 21.5H7.5C5.29086 21.5 3.5 19.7092 3.5 17.5V7.5H5.5Z",
    fill: "black",
    fillOpacity: 0.38
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 2.5C4.29086 2.5 2.5 4.29086 2.5 6.5V7C2.5 7.82843 3.17157 8.5 4 8.5H21C21.8284 8.5 22.5 7.82843 22.5 7V6.5C22.5 4.29086 20.7091 2.5 18.5 2.5H6.5ZM4.5 6.5C4.5 5.39543 5.39543 4.5 6.5 4.5H18.5C19.6046 4.5 20.5 5.39543 20.5 6.5H4.5ZM11 10.5C9.61929 10.5 8.5 11.6193 8.5 13C8.5 14.3807 9.61929 15.5 11 15.5H14C15.3807 15.5 16.5 14.3807 16.5 13C16.5 11.6193 15.3807 10.5 14 10.5H11ZM10.5 13C10.5 12.7239 10.7239 12.5 11 12.5H14C14.2761 12.5 14.5 12.7239 14.5 13C14.5 13.2761 14.2761 13.5 14 13.5H11C10.7239 13.5 10.5 13.2761 10.5 13Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.bc461420365ad523517849190687cdf2.svg";
export { ForwardRef as ReactComponent };